import React from "react";

const Icon = () => (
  <svg viewBox="0 0 149.3 60.9">
    <defs>
      <linearGradient
        id="tdcx"
        y1=".499"
        x2="1"
        y2=".499"
        gradientUnits="objectBoundingBox"
      >
        <stop offset=".4" stopColor="#ea1d25" />
        <stop offset="1" stopColor="#fdb51b" />
      </linearGradient>
    </defs>
    <path
      d="M109.5 60.8a29.251 29.251 0 006.9-3.9l-2.2 3.9zM114.1 0h-4.6a29.251 29.251 0 016.9 3.9zm35.1 0H132l-7.5 13.1a33.82 33.82 0 013.9 11.2l.2 1.4h-16.9l2.8 4.8-2.7 4.7h16.9l-.2 1.4a31.656 31.656 0 01-4 11.3l7.5 13h17.3l-17.5-30.3zM96.8 47.7c-9.3 0-16-7.2-16-17.2a18.327 18.327 0 014.5-12.4 15.34 15.34 0 0111.5-5 14.007 14.007 0 015.4 1L94.1.1a30.981 30.981 0 00-19.4 8.6 29.283 29.283 0 00-3.9 4.8 33.959 33.959 0 014.3 16.9 34.234 34.234 0 01-4.3 16.9 29.959 29.959 0 003.9 4.9 30.981 30.981 0 0019.4 8.6l8-13.9a17.353 17.353 0 01-5.3.8zm28.9-24.4C122.8 9.3 111.4 0 96.8 0l13.4 23.3zm-15.4 14.3L96.9 60.8c14.6 0 26-9.3 28.9-23.2zm-79.5-24h10.7V0L0 .1v13.5h14.8v47.2h16zm41.9 16.8v-1C72.3 17 65.6 7.1 54.8 2.6A37.877 37.877 0 0044 .1v13.7a15.816 15.816 0 018.6 4.4 17.088 17.088 0 014.6 12.2 17.088 17.088 0 01-4.6 12.2c-3 3.1-7.2 4.7-12.2 4.7h-7.1v13.5h9a33.916 33.916 0 0012.4-2.6c10.9-4.5 17.6-14.3 17.9-26.8v-.9c.1 0 .1 0 .1-.1z"
      fill="url(#tdcx)"
    />
  </svg>
);

export default Icon;
